import { createAction as createReduxAction, createRoutine as createReduxRoutine } from "Utils/Redux";

const createAction = <T extends string, P = void>(type: T) => createReduxAction<
	T, P, "WEATHERDATA"
>(type, "WEATHERDATA");

const createRoutine = <
	T extends string,
	TriggerPayload = void,
	RequestPayload = void,
	SuccessPayload = void,
	FailurePayload = void,
	FulfillPayload = void
>(type: T) => createReduxRoutine<
	T,
	TriggerPayload,
	RequestPayload,
	SuccessPayload,
	FailurePayload,
	FulfillPayload,
	"WEATHERDATA"
>(type, "WEATHERDATA");

export default {
	INITIATE: createAction("INITIATE"),
	UNINITIATE: createAction("UNINITIATE"),
	SET_IS_LOADING: createAction<"SET_IS_LOADING", boolean>("SET_IS_LOADING"),
	FETCH_WEATHER_DATA: createRoutine<"FETCH_WEATHER_DATA">("FETCH_WEATHER_DATA"),
	SET_WEATHER_DATA: createAction<"SET_WEATHER_DATA", WeatherReduxType[]>("SET_WEATHER_DATA"),
	ADD_WEATHER_DATA: createAction<"ADD_WEATHER_DATA", WeatherReduxType[]>("ADD_WEATHER_DATA"),
	REMOVE_WEATHER_DATA: createAction<"REMOVE_WEATHER_DATA", [number] | null>("REMOVE_WEATHER_DATA"),
};
